module.exports = __webpack_public_path__ + "media/src/images/download-easy-guide-6e2ead3fd9f7cacbb76f33f5a75c17fe.jpg";